import { useState } from 'react';
import { Button, Badge, Spinner, Offcanvas } from 'react-bootstrap';
import { Bell } from 'react-bootstrap-icons';
import dayjs from 'dayjs';

export default function NotificacionesPanel({ avisos = [], loading, onVerTodos }) {
  const [show, setShow] = useState(false);

  const cantidadAvisos = avisos?.length || 0;

  const handleVerTodos = () => {
    setShow(false);
    onVerTodos?.();
  };

  return (
    <>
      <Button
        variant='outline-light'
        size='sm'
        className='notif-toggle'
        onClick={() => setShow(true)}
        aria-label='Ver notificaciones'
        title='Ver notificaciones'
      >
        <Bell size={18} />

        {cantidadAvisos > 0 && (
          <Badge bg='danger' pill className='notif-badge'>
            {cantidadAvisos}
          </Badge>
        )}
      </Button>

      <Offcanvas
        placement='end'
        show={show}
        onHide={() => setShow(false)}
        className='notif-offcanvas'
      >
        <Offcanvas.Header closeButton>
          <div className='notif-heading'>
            <span className='notif-heading-eyebrow'>Centro de avisos</span>
            <Offcanvas.Title>Próximos vencimientos</Offcanvas.Title>
            <span className='notif-heading-summary'>
              {loading
                ? 'Actualizando información...'
                : cantidadAvisos === 1
                  ? '1 vencimiento requiere atención'
                  : `${cantidadAvisos} vencimientos requieren atención`}
            </span>
          </div>
        </Offcanvas.Header>

        <Offcanvas.Body>
          {loading && (
            <div className='notif-loading'>
              <Spinner animation='border' size='sm' className='me-2' />
              Cargando...
            </div>
          )}

          {!loading && cantidadAvisos === 0 && (
            <div className='notif-empty'>
              No hay avisos pendientes.
            </div>
          )}

          {!loading && cantidadAvisos > 0 && (
            <>
              <div className='notif-list'>
                {avisos.map((v, i) => (
                  <div key={v.id || i} className='notif-card'>
                    <div className='notif-card-title'>
                      {v.servicios?.tipo_servicio || 'Servicio'} —{' '}
                      {v.servicios?.empresa_proveedora || 'Proveedor'}
                    </div>

                    <div className='notif-card-line'>
                      <span>Referencia</span>
                      <strong>{v.servicios?.referencia_cuenta || '—'}</strong>
                    </div>

                    <div className='notif-card-line'>
                      <span>Titular</span>
                      <strong>{v.servicios?.titular || '—'}</strong>
                    </div>

                    <div className='notif-card-line'>
                      <span>Detalle</span>
                      <strong>{v.servicios?.detalle || '—'}</strong>
                    </div>

                    <div className='notif-card-date'>
                      Vence el {dayjs(v.fecha_vencimiento).format('DD/MM/YYYY')}
                    </div>
                  </div>
                ))}
              </div>

              <div className='notif-actions'>
                <Button
                  variant='primary'
                  size='sm'
                  onClick={handleVerTodos}
                >
                  Ver todos los vencimientos
                </Button>
              </div>
            </>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}
